var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "408.000000pt",
    height: "400.000000pt",
    viewBox: "0 0 408.000000 400.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,400.000000) scale(0.100000,-0.100000)",
    fill: "#C0BFC7",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3775 3045 c-169 -30 -315 -147 -400 -318 -63 -126 -92 -271 -105 -522 -14 -268 -30 -343 -89 -429 -48 -69 -75 -77 -248 -74 l-147 3 -13 100 c-16 134 -39 217 -74 265 l-29 40 -950 0 -949 0 -26 -27 c-30 -33 -58 -116 -81 -246 -24 -128 -24 -428 0 -552 27 -143 55 -222 88 -250 l30 -25 938 0 939 0 21 23 c44 45 69 121 95 280 l6 37 142 0 c184 0 255 12 344 56 93 47 139 87 197 171 93 137 146 335 146 551 0 222 40 410 105 496 35 47 88 77 151 84 l44 5 0 173 0 174 -32 -1 c-18 0 -65 -7 -103 -14z m-1694 -1096 c259 -20 386 -44 396 -75 9 -28 -104 -54 -322 -74 -143 -12 -908 -5 -1030 10 -169 21 -246 58 -181 88 32 14 210 40 351 51 163 12 632 13 786 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 1769 c-19 -19 -21 -30 -17 -100 5 -91 42 -177 108 -251 54 -62 92 -78 182 -78 l73 0 -2 222 -2 223 -161 3 c-152 2 -161 1 -181 -19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasSystem);
export default __webpack_public_path__ + "static/media/GasSystem.a4205c1d31e84644a2cf8963791321ab.svg";
export { ForwardRef as ReactComponent };